var map = {
	"./flags/en.svg": 961,
	"./flags/es.svg": 962,
	"./flags/fr.svg": 963,
	"./flags/it.svg": 964,
	"./flags/nl.svg": 965,
	"./flags/pt.svg": 966,
	"./icons/icon-arrow-down.svg": 144,
	"./icons/icon-arrow-up.svg": 145,
	"./icons/icon-beach--green.svg": 967,
	"./icons/icon-beach--red.svg": 968,
	"./icons/icon-beach.svg": 969,
	"./icons/icon-break.svg": 970,
	"./icons/icon-chevron-circle-left--white.svg": 971,
	"./icons/icon-chevron-circle-left.svg": 972,
	"./icons/icon-chevron-circle-right--white.svg": 973,
	"./icons/icon-chevron-circle-right.svg": 974,
	"./icons/icon-chevron-left--white.svg": 975,
	"./icons/icon-info--circle.svg": 976,
	"./icons/icon-legend-buoys.svg": 977,
	"./icons/icon-legend-star.svg": 978,
	"./icons/icon-legend-swell-arrow.svg": 979,
	"./icons/icon-legend-swell.svg": 980,
	"./icons/icon-legend-wind.svg": 981,
	"./icons/icon-loader.svg": 982,
	"./icons/icon-point--green.svg": 983,
	"./icons/icon-point--red.svg": 984,
	"./icons/icon-point.svg": 985,
	"./icons/icon-reef--green.svg": 986,
	"./icons/icon-reef--red.svg": 987,
	"./icons/icon-reef.svg": 988,
	"./icons/icon-river--green.svg": 989,
	"./icons/icon-river--red.svg": 990,
	"./icons/icon-river.svg": 991,
	"./icons/icon-sandbar--green.svg": 992,
	"./icons/icon-sandbar--red.svg": 993,
	"./icons/icon-sandbar.svg": 994,
	"./icons/icon-thumbs-down-solid.svg": 995,
	"./icons/icon-thumbs-up-solid.svg": 996,
	"./icons/icon-tidal-range--blue.svg": 997,
	"./icons/icon-tide-clock--color.svg": 998,
	"./icons/icon-tide-needle.svg": 999,
	"./icons/icon-tide-star.svg": 1000,
	"./logos/apple-logo--black.svg": 1001,
	"./logos/apple-logo--white.svg": 1002,
	"./logos/google-g-logo.svg": 1003,
	"./logos/outside-logo--black.svg": 1004,
	"./logos/outside-logo--white.svg": 1005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 960;